<router-outlet />

<splash-screen *ngIf="isLoading"></splash-screen>